import type {Page, Result, UseCase} from 'framework';
import type {WeightTrackingError} from '../../domain/errors';
import type {WeightEntry} from '../../domain/weight-entry';
import type {WeightTrackingRepository} from '../ports/weight-tracking.repository';

export type ListWeightEntriesInput = {
  readonly cursor: string | null;
};

export class ListWeightEntries implements UseCase<[ListWeightEntriesInput], Page<WeightEntry>> {
  constructor(private readonly repository: WeightTrackingRepository) {}

  execute(input: ListWeightEntriesInput): Promise<Result<Page<WeightEntry>, WeightTrackingError>> {
    return this.repository.list(input.cursor);
  }
}
